export default "__VITE_ASSET__Bx06ZSa$__"